import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import OrderStatus from '../configuration/orderStatus/OrderStatus'
import OrderStatusTypes from '../configuration/orderStatus/OrderStatusTypes'

const MainOrderStatus = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Order Status'),
      component: <OrderStatus />,
      to: '/configuration/picklist/orderStatus',
      permissionCode: 'ORDER_STATUS_TAB'
    },
    {
      title: t_('Order Status types'),
      component: <OrderStatusTypes />,
      to: '/configuration/picklist/orderStatusTypes',
      permissionCode: 'ORDER_STATUS_TYPE_TAB'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainOrderStatus
